<template>
    <div >
      <b-modal v-if="!this.recNo"
        id="patientMedications" 
        size="md" 
        centered 
        :title="$t('PatientMedications.ReportMedications')" 
        :visible="true"
        :no-close-on-backdrop="true" 
        @ok="onClickShowReport" 
        @cancel="onClickClose"
        @close="onClickClose">
        <b-row>
          <b-col lg="6" md="6" sm="6">
            <MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom">                                     
            </MdEdit>
          </b-col>
          <b-col lg="6" md="6" sm="6">
            <MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo">                                     
            </MdEdit>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" md="6" sm="6">
            <MdSelect
              v-bind:Label="$t('Shared.Status')"
              v-bind:Options="StatusOptions"
              v-bind:ModelArray="status"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Multiple="false"
              :Input="ChangeDropDownStatus"/>
          </b-col>
        </b-row>
      </b-modal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('PatientMedications.ReportMedications')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
        :wrapper-attr="popupAttributes"
      >
        <ReportViewer
          ref="patientMedications"
          :ReportName="'PatientMedications'"
          :ReportTitle="$t('PatientMedications.ReportMedications')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import Utils from '../../../common/utils'
    import EnumService from "@/services/enum.service";

    export default Vue.extend({
        name: "PatientMedicationsRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          patientCode: String,
          recNo: String,
          isControlledSubstance: String,
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                dateFrom: !this.recNo ? Utils.formatterDate(Date(), "LLLL") : null,
                dateTo: !this.recNo ? Utils.formatterDate(Date(), "LLLL") : null,
                reportParams: [],
                popupAttributes: {
                  id: 'modalpatientMedications'
                },
                StatusOptions: EnumService.MedicationStatusReport,
                status : { value: 'ALL', text: 'All' },
            }
        },
        methods: {

            ChangeDropDownStatus(item) {
              this.status = item 
            },

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onClickShowReport() {
              this.isParamVisible = false

              this.reportParams = []
              
              if (!this.recNo ) {
                this.reportParams.push({ paramName: 'dateFrom', paramValue: this.dateFrom ?? null})
                this.reportParams.push({ paramName: 'dateTo', paramValue: this.dateTo ?? null})
                this.reportParams.push({ paramName: 'status', paramValue: this.status.value})
              }

              this.reportParams.push({ paramName: 'patientCode', paramValue: this.patientCode ?? null})
              this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo ?? null})
              this.reportParams.push({ paramName: 'isControlledSubstance',  paramValue: this.isControlledSubstance ?? null})
              this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})

              this.isReportVisible = true
              this.$refs.patientMedications.buildDocument(this.reportParams)
            }
        },
        
        mounted () {
          if (this.recNo)
           this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
